import type { FilterFormType } from '@lighthouse/core'
import { DataSourceType } from '@lighthouse/core'
import { getIsAllowedDataSourceAsFlowOption, getTableIcon, type MatchConditionTriggerConfig } from '@lighthouse/shared'
import React, { useMemo, useState } from 'react'

import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'
import { useDataSourceList } from '@/hooks/useDataSource'

import * as CM from '../styles'
import * as SC from './styles'

type MatchConditionCardProps = {
    config: MatchConditionTriggerConfig
}
const conditionCount = (filter: FilterFormType) => {
    const num = filter?.expression?.conditions?.length || 0

    return num ? `已设置${num}个条件` : '未设置条件'
}

const MatchConditionCard: React.FC<MatchConditionCardProps> = ({ config }) => {
    const { filter, dataSourceId } = config

    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()
    const listDs = useDataSourceList(appId, envId)

    const options = useMemo(
        () =>
            listDs.reduce<{ label: string; icon: string; value: string }[]>((listDs, item) => {
                const tableIcon = getTableIcon(item)
                if (getIsAllowedDataSourceAsFlowOption(item)) {
                    listDs.push({
                        value: item.id,
                        label: item.name,
                        icon: tableIcon
                    })
                }
                return listDs
            }, []),
        [listDs]
    )

    const option = useMemo(() => (dataSourceId ? options.find(item => item.value === dataSourceId) : undefined), [dataSourceId, options])

    if (!option) {
        return null
    }

    return (
        <CM.CardItemContainer>
            <SC.TypeName>当记录满足指定条件时</SC.TypeName>

            <CM.FieldList>
                <CM.FieldItem>
                    <CM.FieldItemLeftFill>
                        <SC.Icon type={option?.icon || 'tableIcon'} />
                        <CM.FieldItemTitle>{option?.label}</CM.FieldItemTitle>
                    </CM.FieldItemLeftFill>
                </CM.FieldItem>
            </CM.FieldList>

            <SC.TypeName>触发条件</SC.TypeName>
            <CM.FieldItemContent>
                <CM.FieldItemTitle>{conditionCount(filter)}</CM.FieldItemTitle>
            </CM.FieldItemContent>
        </CM.CardItemContainer>
    )
}

export default MatchConditionCard
